import React, { useEffect, useState } from 'react';
import { ChromePicker } from 'react-color';
import classNames from 'classnames';
import { useClickOutside } from 'helpers/use_click_outside';

interface ColorPickerProps {
  value?: string;
  colors: string[];
  onChange: (value: string) => void;
  variant?: 'v2';
  customColorOnly?: boolean;
  id?: string;
  onToggle?: (open) => void;
}

const ColorPicker = ({
  colors,
  value,
  onChange,
  variant,
  customColorOnly,
  id,
  onToggle,
}: ColorPickerProps) => {
  const [customColorPickerVisible, toggleCustomColorPicker] = useState(false);
  const [ref, hasClickedOutside] = useClickOutside();

  const isCustomColorSelected = () => {
    return value && colors.indexOf(value) === -1;
  };

  useEffect(() => {
    if (onToggle) {
      onToggle({ [id]: customColorPickerVisible });
    }
  }, [customColorPickerVisible, id, onToggle]);

  useEffect(() => {
    if (hasClickedOutside) {
      toggleCustomColorPicker(false);
    }
  }, [hasClickedOutside]);

  return (
    <div
      className={classNames('color-picker-container', {
        'color-picker-container--v2': variant === 'v2',
      })}
    >
      <span ref={ref}>
        {!customColorOnly &&
          colors.map((color) => (
            <button
              key={color}
              type="button"
              className="color-cell"
              onClick={() => {
                toggleCustomColorPicker(false);

                onChange(value === color ? null : color);
              }}
              style={{ background: color }}
            >
              {value === color && <i className="icon-checkmark"></i>}
            </button>
          ))}

        <button
          type="button"
          className="color-cell color-picker"
          onClick={() => {
            toggleCustomColorPicker((open) => !open);
          }}
          style={{ background: isCustomColorSelected() ? value : undefined }}
        >
          {isCustomColorSelected() && <i className="icon-checkmark"></i>}
        </button>

        {customColorPickerVisible && (
          <div className="color-picker-wrapper">
            <ChromePicker
              disableAlpha
              color={value}
              onChange={(data) => {
                onChange(data.hex);
              }}
            />
          </div>
        )}
      </span>
    </div>
  );
};

export default ColorPicker;
